import { render, staticRenderFns } from "./IntOrderDetail.vue?vue&type=template&id=690d5503&scoped=true&"
import script from "./IntOrderDetail.vue?vue&type=script&lang=js&"
export * from "./IntOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./IntOrderDetail.vue?vue&type=style&index=0&id=690d5503&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690d5503",
  null
  
)

export default component.exports